<template>
    <div class="animated fadeIn">
        <div class="card">
            <div class="card-body">
                <el-upload
                    action
                    :auto-upload="false"
                    :show-file-list="false"
                    list-type="picture-card"
                    :limit="mData.fileUploadOption.Anh.limit"
                    :accept="mData.fileUploadOption.Anh.accept"
                    :on-change="fn_uploadChangeAlbumAnh"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                    title="Tips"
                    :visible.sync="dialogVisible"
                    class="cropper-dialog"
                >
                    <div>
                        <croppa 
                            v-model="myCroppa"
                            :width="400"
                            :height="500"
                            placeholder="Choose an image"
                            :placeholder-font-size="0"
                            :disabled="false"
                            :prevent-white-space="true"
                            :show-remove-button="false"
                        >
                            <img crossOrigin="anonymous"
                                :src="imageSrc"
                                slot="initial"
                            >
                            <p>Kéo ảnh vừa với khung để tải lên</p>
                        </croppa>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">Cancel</el-button>
                        <el-button @click="uploadCroppedImage" type="primary">Save</el-button>
                    </span>
                </el-dialog>
                
            </div>
        </div>
    </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from '../../../service/MethodService';
export default {
    name: "cards",
    data: function () {
        return {
            imgURL: ExtensionService.urlImg,
            imageSrc:"",
            myCroppa: {},
            dialogVisible: false,
            mData:{
                fileUploadOption:{
                    Anh:{
                        limit: null,
                        accept: ".jpg, .png, .jpeg, .mp4, .avi, .mov",
                        dialogImageUrl: "",
                        dialogVisible: false,
                        fileList: []
                    }
                }
            }
        };
    },
    methods: {
        uploadCroppedImage() {
            let a = this.myCroppa.generateDataUrl('image/jpeg')
            console.log("qiewuriuerwuerwioeur",a);
        },
        fn_uploadChangeAlbumAnh(file) {
            let fileName = file.name;
            ExtensionService.upload(file, "anhAlbum")
            .then((res) => {
                this.imageSrc = this.imgURL + res.result;
                console.log("this.fileName",fileName);
                this.dialogVisible = true;
            })
            .catch(() => {});
        },
    },
    created: function(){
        console.log(this.myCroppa);
    }
};
</script>
<style scoped>
::v-deep .cropper-dialog .el-dialog{
    margin-top: 10vh !important;
    width: 35%;
}
::v-deep .cropper-dialog .el-dialog__body{
    padding-top: 25px;
}
::v-deep .cropper-dialog .el-dialog__body .croppa-container{
    text-align: center;
}
::v-deep .cropper-dialog .el-dialog__body canvas{
        width: 400px ;
        height: 500px ;
    }
::v-deep .cropper-dialog .el-dialog__body canvas:hover{
    cursor: all-scroll;
}
::v-deep .cropper-dialog .el-dialog__footer{
    text-align: center;
}
@media (max-width: 1238px) {
    ::v-deep .cropper-dialog .el-dialog{
        width: 50%;
    }
}
@media (max-width: 870px) {
    ::v-deep .cropper-dialog .el-dialog{
        width: 65%;
    }
}
@media (max-width: 660px) {
    ::v-deep .cropper-dialog .el-dialog{
        width: 80%;
    }
}
@media (max-width: 540px) {
    ::v-deep .cropper-dialog .el-dialog{
        width: 98%;
    }
}
@media (max-width: 440px) {
    ::v-deep .cropper-dialog .el-dialog__body canvas{
        width: 320px !important;
        height: 420px !important;
    }
}
@media (max-width: 356px) {
    ::v-deep .cropper-dialog .el-dialog__body canvas{
        width: 273px !important;
        height: 345px !important;
    }
}
</style>